module.exports = __webpack_public_path__ + "img/diariomunicipios.40a33915.png";